export default {
  'Custom': 'कस्टम',
  'Original': 'मूल',
}